import { render, staticRenderFns } from "./PaperPage.vue?vue&type=template&id=77c71140&scoped=true"
import script from "./PaperPage.vue?vue&type=script&lang=js"
export * from "./PaperPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c71140",
  null
  
)

export default component.exports